import {
  queryOptions,
  infiniteQueryOptions,
  keepPreviousData
} from '@tanstack/react-query';
import { driversApi } from './drivers.api';
import type { DriversListParams } from '../types';

export const driverKeys = {
  all: ['drivers'] as const,
  lists: () => [...driverKeys.all, 'list'] as const,
  list: (filters: DriversListParams) =>
    [...driverKeys.lists(), filters] as const,
  infiniteLists: () => [...driverKeys.all, 'infinite'] as const,
  infiniteList: (filters: DriversListParams) =>
    [...driverKeys.infiniteLists(), filters] as const,
  details: () => [...driverKeys.all, 'detail'] as const,
  detail: (id: number) => [...driverKeys.details(), id] as const
};

export const driverQueries = {
  list: (filters: DriversListParams = {}) =>
    queryOptions({
      queryKey: driverKeys.list(filters),
      queryFn: () => driversApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  /**
   * Page-cursor infinite variant for scroll-to-load surfaces (e.g. the
   * shipping driver-selection panel). `filters` must not include `page` —
   * the cursor owns it.
   */
  infiniteList: (filters: DriversListParams = {}) =>
    infiniteQueryOptions({
      queryKey: driverKeys.infiniteList(filters),
      queryFn: ({ pageParam }) =>
        driversApi.getAll({ ...filters, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) =>
        lastPage.pagination?.hasNext ? lastPage.pagination.page + 1 : undefined,
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: driverKeys.detail(id),
      queryFn: () => driversApi.getById(id),
      enabled: id > 0
    })
};
